module.exports = __webpack_public_path__ + "img/landingcrewants.1e399c3d.png";